import React from 'react';
import VideoInfoModule from 'components/templates/videoInfoModule';
import { StringUtil } from 'utils/StringUtil';

const HistoryMoments = ({ data }) => {
  const {
    historyMoments: {
      heading,
      sub_heading,
      paragraph,
      video,
      video_thumbnail_url,
    },
  } = data.data;
  const headingData = StringUtil.sliceHtml(heading);
  const content = StringUtil.sliceHtml(paragraph);
  const videoData = () => {
    return { __html: video };
  };

  return (
    <VideoInfoModule
      containerClassName={'history-moments'}
      heading={headingData}
      subHeading={sub_heading}
      content={content}
      videoData={videoData()}
      videoThumbnailUrl={video_thumbnail_url}
      buttonName={''}
    />
  );
};

export default HistoryMoments;
